import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectDialogs, setMode } from '../ChatApp/chatSlice';
import dialogApi from '../../api/dialogApi';
import './Sidebar.css';
import { selectUserId } from '../Login/loginSlice';
import { useHeaderChatActions } from '../../hooks/useHeaderChatActions'
import { useHeaderLogic } from '../../hooks/useHeaderLogic';
import { selectIsBindPay, selectUserEmail, setIsStart } from '../Login/loginSlice';
import { useHeaderNavigation } from '../../hooks/useHeaderNavigation';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../../static/img/logo.png'
import { FiSidebar } from "react-icons/fi";
import { CiCirclePlus } from "react-icons/ci";
import { GoLaw } from "react-icons/go";
import { BsThreeDotsVertical } from 'react-icons/bs';
import { Tooltip } from 'react-tooltip';
import UserCart from '../Userbar/UserCart';



const Sidebar = ({ onDialogSelect, selectedDialogId, fetchDialogs, isSubscription, dialogId }) => {

    const location = useLocation();
    const dispatch = useDispatch();
    const dialogs = useSelector(selectDialogs);
    const userId = useSelector(selectUserId)
    const [contextMenu, setContextMenu] = useState(null);
    const userEmail = useSelector(selectUserEmail)
    const [collapsed, setCollapsed] = useState(false);
    const [userCart, setUserCart] = useState(null)
    const userCartRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (userCartRef.current && !userCartRef.current.contains(event.target)) {
                setUserCart(null);
            }
        };

        if (userCart) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [userCart]);





    const { handleStartNewDialog, handleStartProcessingMessageToLawyer } = useHeaderChatActions();
    const { logout, checkSubscription, fetchProfile } = useHeaderLogic();


    // useEffect(() => {
    //     checkSubscription(userEmail, (v) => dispatch(setIsStart(v)));
    // }, [userEmail]);

    const { navigateToProfile,
        navigateToChat,
        navigateToStorage,
        navigateToLogin,
        navigateToMain } = useHeaderNavigation();

    // Открытие контекстного меню
    const handleContextMenu = (event, dialog) => {
        event.preventDefault();
        setContextMenu({
            x: event.clientX,
            y: event.clientY,
            dialog
        });
    };

    // открытие карты пользователя для работы с персональными данными
    const handleUserCart = (event) => {
        event.preventDefault();
        const offsetY = 300;
        setUserCart({
            x: event.clientX,
            y: event.clientY - offsetY,
        })
    }


    const initials = userEmail.slice(0, 2).toUpperCase();

    const getColorFromEmail = (userEmail) => {
        let hash = 0;
        for (let i = 0; i < userEmail.length; i++) {
            hash = userEmail.charCodeAt(i) + ((hash << 5) - hash);
        }

        const hue = hash % 360;           // Цветовой тон
        const saturation = 85;            // Насыщенность
        const lightness = 35;             // Яркость — меньше = темнее

        return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    };


    const avatarColor = getColorFromEmail(userEmail);

    // Закрытие контекстного меню
    const handleCloseMenu = () => setContextMenu(null);

    const handleCloseUserCart = () => setUserCart(null);

    // Удаление диалога
    const handleDeleteDialog = async () => {
        if (contextMenu && window.confirm("Вы уверены, что хотите удалить этот диалог?")) {
            try {
                await dialogApi.deleteDialog(contextMenu.dialog.id);
                //console.log("Диалог удалён:", contextMenu.dialog.id);
                localStorage.removeItem(`lastDialogId_${userId}`);
                localStorage.removeItem(`lastDialogName_${userId}`);
                fetchDialogs();
                dispatch(setMode('dialogs'))
            } catch (error) {
                console.error("Ошибка удаления:", error);
            }
            handleCloseMenu();
        }
    };

    const handleClickToDialogs = () => {
        dispatch(setMode('chat'))
    }


    return (
        <div className={`sidebar ${collapsed ? 'collapsed' : ''}`} onClick={handleCloseMenu}>
            <div className='sidebar_header'>
                <div onClick={() => handleStartNewDialog()}>
                    <img src={logo} className='header_logo' />
                </div>
                <div
                    className="sidebar_movers"
                    onClick={() => {
                        setCollapsed(!collapsed);
                        handleClickToDialogs();
                    }}
                >

                    <FiSidebar
                        className='sidebar_mover'
                        data-tooltip-id="custom-tooltip"
                        data-tooltip-content="Свернуть/развернуть меню"
                        data-tooltip-place="right"
                    />
                </div>
            </div>
            {/* ВЕРХ */}
            <div className="sidebar_top">
                <div className='sidebar_buttons'
                    onClick={() => {
                        handleClickToDialogs();
                        handleStartNewDialog()
                    }}
                >
                    <CiCirclePlus className='sidebar_mover'
                        data-tooltip-id="custom-tooltip"
                        data-tooltip-content="Добавить новый диалог"
                        data-tooltip-place="right"
                    />
                    <div className='sidebar-button-text'>Новый диалог</div>
                </div>
                <div className='sidebar_buttons'
                    onClick={() => {
                        handleStartProcessingMessageToLawyer()
                        handleClickToDialogs();
                    }}
                >
                    <GoLaw className='sidebar_mover'
                        data-tooltip-id="custom-tooltip"
                        data-tooltip-content="Вопрос юристу"
                        data-tooltip-place="right"
                    />
                    <div className='sidebar-button-text'>Вопрос юристу</div>
                </div>
                {/* <button onClick={handleStartNewDialog}>Новый диалог</button>
      <button onClick={handleStartProcessingMessageToLawyer}>Вопрос юристу</button> */}
            </div>

            {/* СЕРЕДИНА (скролл) */}
            <div className="sidebar_middle">
                <div className="sidebar_middle_dialogs">
                    <h2>Диалоги</h2>
                    <ul>
                        {dialogs.map((dialog) => (
                            <li
                                key={dialog.id}
                                className={`${dialog.id === parseInt(selectedDialogId) ? "active" : ""
                                    } ${dialog.id === contextMenu?.dialog?.id ? "delete_dialog" : ""}`.trim()}
                                onClick={() => onDialogSelect(dialog.id)}
                                onContextMenu={(e) => handleContextMenu(e, dialog)}
                            >
                                <div className="dialog_info">
                                    <div className="dialog_name" title={dialog.name}>
                                        {dialog.name?.charAt(0).toUpperCase() + dialog.name?.slice(1) || "Диалог"}
                                    </div>
                                    <span className="dialog_date">
                                        {dialog.last_message_at
                                            ? new Intl.DateTimeFormat("ru-RU", {
                                                year: "numeric",
                                                month: "2-digit",
                                                day: "2-digit",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                            }).format(new Date(dialog.last_message_at))
                                            : "—"}
                                    </span>
                                </div>

                                <BsThreeDotsVertical
                                    className="dialog_menu_icon"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleContextMenu(e, dialog);
                                    }}
                                />
                            </li>
                        ))}
                    </ul>
                </div>

                {contextMenu && (
                    <div
                        className="context-menu"
                        style={{ top: contextMenu.y, left: contextMenu.x }}
                        onClick={handleCloseMenu}
                    >
                        <button onClick={handleDeleteDialog}>Удалить</button>
                    </div>
                )}
            </div>



            {/* НИЗ */}
            <div className="sidebar_bottom">
                <div className="user-info">
                    {/* <div className='sidebar_profile'>
            {(isSubscription)?
            <p>Тариф подключен</p>:
            <p>Подключите тариф</p>
            }
            <div
                // className={location.pathname === '/profile' ? '' : 'deactive'}
                className='sidebar_profile_buttons'
                onClick={() => navigateToProfile()}
            >
                Личный Кабинет
            </div>
        </div> */}
                    <div className="user-card"
                        onClick={(e) => handleUserCart(e)}
                    >
                        <div className="user-avatar" style={{ backgroundColor: avatarColor }}>
                            {initials}
                        </div>
                        <div className="user-email-info">
                            <div className="user-email">{userEmail}</div>
                        </div>
                    </div>
                    {userCart && (
                        <div
                            ref={userCartRef} // <--- ВАЖНО: ref должен быть на внешнем контейнере UserCart
                            style={{
                                position: "absolute",
                                zIndex: 9999,
                            }}
                        >
                            <UserCart
                                userId= {userId}
                                userEmail={userEmail}
                            />
                        </div>
                    )}

                    {/* <button
            className={location.pathname === '/storage' ? '' : 'deactive'}
            onClick={() => navigateToStorage()}
        >
            Хранилище
        </button> */}
                    {/* <button
            onClick={()=> logout()}
        >Выйти</button> */}
                </div>
            </div>
            {collapsed ?
                <Tooltip
                    id="custom-tooltip"
                    place="right"
                    style={{
                        backgroundColor: "#222",   // background
                        color: "#fff",              // text color
                        fontSize: "14px",
                        borderRadius: "8px",
                        padding: "8px 12px",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                        zIndex: 9999,
                    }} /> : <div></div>}

        </div>
    );

};

export default Sidebar;
